import { render, staticRenderFns } from "./EmergencyResponseDetailRight.vue?vue&type=template&id=478b6d99&scoped=true"
import script from "./EmergencyResponseDetailRight.vue?vue&type=script&lang=js"
export * from "./EmergencyResponseDetailRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478b6d99",
  null
  
)

export default component.exports